/**
 * Recursively free geometries, materials and textures owned by an object tree.
 * Materials/textures referenced by several meshes will be disposed more than
 * once, which is safe in Three.js but worth knowing when sharing resources.
 */
export function disposeObject3D(root) {
  if (!root) return;

  root.traverse((object) => {
    if (object.geometry) object.geometry.dispose();

    if (!object.material) return;

    const materials = Array.isArray(object.material) ? object.material : [object.material];
    for (const material of materials) {
      for (const value of Object.values(material)) {
        if (value && value.isTexture) value.dispose();
      }
      material.dispose();
    }
  });

  root.removeFromParent();
}
